<template lang="pug">
v-container
  v-row(no-gutters)
    v-col(cols="12" sm="5")
      .d-flex.align-center
        v-text-field.round-lg.search-input(v-model="searchText" @input="queryChanged" :placeholder="$t('search_donors')" hide-details dense solo flat height="40" :background-color="$colors.basic200")
          template(v-slot:append)
            eva-icon(name="search-outline" :fill="$colors.primary400")
        //- div(v-if="isMobileScreen")
          v-btn.ml-3(@click="addFilter" icon)
            v-icon $yzi-filter-line
          v-menu(rounded="lg" offset-y :close-on-content-click="false")
            template(v-slot:activator="{ on }")
              v-btn(icon v-on="on")
                v-icon $yzi-settings-02
            customize-customer-column(type="donor")
    //- v-col(cols="12" sm="7" v-if="!isMobileScreen")
      .d-flex.align-center
        v-btn.mt-1.px-3.button-text-normal.ml-2(v-if="!containFilter" @click="addFilter" outlined rounded height="32" :color="$colors.primary200")
          .text-xs.text-none.primary--text {{ $t('add_filter') }}
          v-icon(right color="primary" small) mdi-plus
        v-btn.mt-1.pl-3.pr-1.ml-2(v-else @click="addFilter" outlined depressed rounded height="32" :color="$colors.primary" :style="`background-color: ${$colors.primaryT08}`")
          .text-sm.font-normal.text-none.primary--text {{ $t('filter_applied') }}
          eva-icon.mt-1(name="chevron-right" fill="#333")

  v-row(align="center" v-if="!isMobileScreen")
    v-col(cols="12" md="6")
      .d-flex.align-center
        v-btn.button-Aa-small.mr-3.px-3(v-if="selectedCustomers.length" @click="onDelete" color="danger500" height=32 outlined depressed) {{ $t('delete') }}
        v-btn.button-Aa-small.mr-3.px-3(v-if="selectedCustomers.length" @click="onAddSegment" color="primary" outlined height=32 depressed) {{ $t('add_to_segment') }}
        v-btn.button-Aa-small.mr-3.px-3(v-if="selectedCustomers.length" @click="onSendSms" color="primary" outlined height=32 depressed) {{ $t('send_sms') }}
        v-btn.button-Aa-small.mr-3.px-3(v-if="selectedCustomers.length" @click="onSendEmail" color="primary" outlined height=32 depressed) {{ $t('send_email') }}
        a.link-s(v-if="selectedCustomers.length" @click="clearSelection") {{ $t('clear_selection') }}
        v-spacer
    v-col(cols="12" md="6")
      .d-flex.align-center.justify-end
        v-menu(rounded="lg" offset-y :close-on-content-click="false" min-width=300 max-height=320)
          template(v-slot:activator="{ on: menu, attrs }")
            v-tooltip(top color="black")
              template(v-slot:activator="{ on: tooltip }")
                v-btn(icon v-bind="attrs" v-on="{ ...menu, ...tooltip }" small)
                  v-icon $yzi-settings-02
              .c1.white--text {{ $t('customize_column') }}
          customize-customer-column(type="donor")
        yc-pagination-custom.ml-4(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" :text="$t('show_donors')" @input="pageChanged")
  div.mt-4(v-else)
    v-divider
    .d-flex.align-center.py-3
      yc-checkbox(v-model="checkAll" @change="onCheckedAll")
      v-menu(v-if="selectedCustomers.length" offset-y)
        template(v-slot:activator="{ on, attrs }")
          v-btn.button-Aa-small(v-on="on" text height=32) Action ({{ selectedCustomers.length }})
            v-icon.ml-1(small) mdi-chevron-down
        v-list
          v-list-item(@click="onDelete")
            .p2.danger500--text {{ $t('delete') }}
          v-list-item(@click="onAddSegment")
            .p2 {{ $t('add_to_segment') }}
          v-list-item(@click="onSendSms")
            .p2 {{ $t('send_sms') }}
          v-list-item(@click="onSendEmail")
            .p2 {{ $t('send_email') }}
          v-list-item(@click="clearSelection")
            .p2 {{ $t('clear_selection') }}
      v-spacer
      yc-pagination(v-model="currentPage" :pageSize="pageSize" :count="totalCount")
    v-divider
  .text-center(v-if="isLoading")
    v-data-table.mt-3(:headers="headers" hide-default-footer disable-sort)
      template(v-slot:no-data)
        div
    v-progress-circular(width="2" size="50" color="primary" indeterminate)
  .yc-table(v-else)
    v-data-table.mt-sm-4.pb-16(:headers="headers" :items="customers" item-key="id" :items-per-page="pageSize" :hide-default-header="isMobileScreen" hide-default-footer disable-sort)
      template(v-slot:no-data)
        .mt-16
          v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
          .mt-2.p2.basic600--text {{ $t('no_list_available') }}
      template(v-slot:header.checked)
        yc-checkbox(v-model="checkAll" @change="onCheckedAll")
      template(v-slot:header.phone)
        div {{ 'phone' | fieldNameDisplay }}
      template(v-slot:header.total_paid)
        div {{ 'total_paid' | fieldNameDisplay }}
      template(v-slot:header.marital_status)
        div {{ 'marital_status' | fieldNameDisplay }}
      template(v-slot:item="{ item, isMobile, headers, index }")
        tr.primary--text(v-if="!isMobile")
          td.py-4(v-for="header in headers")
            template(v-if="header.value === 'checked'")
              yc-checkbox(v-model="item.checked" @change="onChecked")
            template(v-else-if="header.value === 'name'")
              .font-semibold {{ item.name }}
            template(v-else-if="header.value === 'total_paid'")
              .div {{ item.total_paid | displayPrice }}
            template(v-else-if="header.value === 'created'")
              div {{ item.created | convertServerDate }}
            template(v-else-if="header.value === 'gender'")
              div {{ item.gender | capitalize }}
            template(v-else-if="header.value === 'marital_status'")
              div {{ item.marital_status | capitalize }}
            template(v-else)
              div {{ getFieldData(header.value, item) }}
        template(v-else)
          .d-flex.py-3.align-start
            yc-checkbox.mt-1(v-model="item.checked" @change="onChecked")
            .ml-4.flex-grow-1
              .s1.mb-2 {{ item.name }}
              template(v-for="header in headers")
                .d-flex.mb-1.p1(v-if="header.value !== 'checked' && header.value !== 'name'")
                  .flex-grow-1
                    .basic600--text {{ header.text | fieldNameDisplay }}
                  div(v-if="header.value === 'created'") {{ item.created | convertServerDate }}
                  div(v-else-if="header.value === 'gender'") {{ item.gender | capitalize }}
                  div(v-else-if="header.value === 'marital_status'") {{ item.marital_status | capitalize }}
                  div(v-else) {{ getFieldData(header.value, item) }}
          v-divider
    .py-8
    .yc-fixed-bottom-section(v-if="isMobileScreen")
      yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" text="Show customers" @input="pageChanged")
      slot(name="actions")
  filter-customer-drawer(:open.sync="showFilterDrawer")
  delete-customer-segment-dialog(v-if="showDeleteDialog" :open.sync="showDeleteDialog" :customers="selectedCustomers" :segment="segment" @deleted="successDeleteCustomer")
  add-segment-dialog(v-if="showAddDialog" :open.sync="showAddDialog" :customers="selectedCustomers" @success="successAddCustomer")
</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'
import CustomizeCustomerColumn from '@/components/connect/CustomizeCustomerColumn.vue'
import FilterCustomerDrawer from '@/components/donation/FilterCustomerDrawer.vue'
import DeleteCustomerSegmentDialog from '@/components/connect/dialogs/DeleteCustomerSegmentDialog.vue'
import AddSegmentDialog from '@/components/connect/dialogs/AddSegmentDialog.vue'

export default {
  name: 'SegmentDonors',
  props: ['group', 'segment'],
  components: {
    CustomizeCustomerColumn,
    FilterCustomerDrawer,
    DeleteCustomerSegmentDialog,
    AddSegmentDialog
  },
  data: () => ({
    isLoading: false,
    searchText: '',
    currentPage: 1,
    pageSize: 20,
    totalCount: 0,
    customers: [],
    selectedCustomers: [],
    showFilterDrawer: false,
    isDeleting: false,
    checkAll: false,
    showDeleteDialog: false,
    showAddDialog: false,
    activeStyle: {
      border: '1.5px solid #0C6DFF',
      borderRadius: '4px',
      padding: '16px',
      cursor: 'pointer'
    },
    inactiveStyle: {
      border: '1px solid var(--v-basic400)',
      borderRadius: '4px',
      padding: '16px',
      cursor: 'pointer'
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      filters: 'customers/getFilters',
      fields: 'donation/getAllFields'
    }),
    headers() {
      const filteredOptions = this.fields.filter(item => item.enable)
      const checkbox = {
        text: '',
        value: 'checked'
      }
      const name = {
        text: 'Name',
        value: 'name',
        class: 'text-table-header'
      }
      filteredOptions.map(item => {
        item.text = item.field_name
        item.value = `${item.id}`.toLowerCase()
        item['class'] = 'text-table-header'
      })
      return [checkbox, name, ...filteredOptions]
    },
    containFilter() {
      let data = false
      for (const key in this.filters) {
        const value = this.filters[key]
        if (value) {
          data = true
        }
      }
      return data
    },
    isMobileScreen() {
      return this.$vuetify.breakpoint.xs
    }
  },
  watch: {
    pageSize() {
      this.fetchCustomers(1)
    },
    filters: {
      deep: true,
      handler() {
        this.selectedCustomers = []
        this.fetchCustomers(1)
      }
    }
  },
  created() {
    this.$store.commit('customers/resetFilters')
    this.fetchCustomFields()
  },
  methods: {
    ...mapActions(['showMessage']),
    addFilter() {
      this.showFilterDrawer = true
    },
    getCustomers(page, pageSize, query, filters) {
      const params = {
        page_size: pageSize,
        page,
        search: query || '',
        groups: this.group
      }
      for (const key in filters) {
        const value = filters[key]
        if (value) {
          params[key] = value
        }
      }
      return this.$axios.get(`/donations/${this.company.slug}/donors`, { params })
    },
    fetchCustomers(page, query) {
      this.isLoading = true
      this.getCustomers(page, this.pageSize, query, this.filters)
      .then(resp => {
        const data = resp.data
        this.customers = data.results
        this.customers.map(item => {
          item.checked = false
        })
        this.totalCount = data.count
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    fetchCustomFields() {
      this.$axios.get(`/connect/${this.company.slug}/customer_custom_fields?page_size=-1`)
      .then(resp => {
        const results = resp.data?.results
        if (results) {
          const fields = []
          results.forEach(field => {
            field.enable = false
            fields.push(field)
          })
          this.$store.commit('donation/setCustomFields', fields)
        }
      })
      .catch(() => {})
    },
    pageChanged(num) {
      this.fetchCustomers(num)
    },
    queryChanged: debounce(function (query) {
      this.fetchCustomers(1, query)
    }, 750),
    successDeleteCustomer() {
      this.reset()
    },
    onChecked() {
      this.selectedCustomers = this.customers.filter(item => item.checked === true)
      this.customers = [...this.customers]
      this.checkAll = false
      this.emitSelectedCustomers()
    },
    onCheckedAll() {
      const clone = [...this.customers]
      clone.map(item => item.checked = this.checkAll)
      this.customers = [...clone]
      this.selectedCustomers = this.customers.filter(item => item.checked === true)
      this.emitSelectedCustomers()
    },
    clearSelection() {
      this.checkAll = false
      this.onCheckedAll()
    },
    onDelete() {
      this.showDeleteDialog = true
    },
    onAddSegment() {
      this.showAddDialog = true
    },
    onSendSms () {
      this.$store.commit('donation/selectDonors', this.selectedCustomers)
      this.$router.push(`/admin/donation/segments/${this.group}/send-message`)
    },
    onSendEmail () {
      this.$store.commit('donation/selectDonors', this.selectedCustomers)
      this.$router.push(`/admin/donation/segments/${this.group}/send-email`)
    },
    successAddCustomer() {
      this.reset()
    },
    reset() {
      this.checkAll = false
      this.selectedCustomers = []
      this.fetchCustomers(1)
      this.$emit('deleted')
    },
    onContinue() {
      this.$emit('onContinue', this.selectedCustomers)
    },
    emitSelectedCustomers() {
      this.$emit('onSelectedCustomers', this.selectedCustomers)
    },
    getFieldData(id, field) {
      const data = field[id]
      if (data) {
        return data
      }
      if (field.custom_data.length) {
        const custom = field.custom_data.find(i => `${i.id}` === id)
        if (custom) {
          return custom.value
        }
      }
      return ''
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>